import React, {useState, useEffect} from "react";
import { Box, Stack, Typography, Card, CardContent, Button, Divider, Link, Breadcrumbs, Grid, IconButton, CircularProgress } from "@mui/material";
import { FlexStart, FlexCenter, FlexRowCenter, FlexEnd } from "components/FlexBox/FlexBox";
import ImageUploader from "components/Images/ImageUploader";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import CountertopsOutlinedIcon from "@mui/icons-material/CountertopsOutlined";
import ShowerOutlinedIcon from "@mui/icons-material/ShowerOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import { baseURL } from "services/API";
import SendIcon from '@mui/icons-material/Send';
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FormDialog from "components/modal";
import axios from "axios";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import TopSnack from "components/TopSnack";
import FlexBetween from "components/FlexBetween";
import UnitDetailsEditForm from "components/Forms/UnitDetailsEditForm";
import UnitMetaDataEditForm from "components/Forms/UnitMetaDataEditForm";
import ApartmentIcon from "@mui/icons-material/Apartment";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import StorefrontIcon from "@mui/icons-material/Storefront";

const facilityIcons = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#52524e",
};

const coloredIconGreen = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#0af047",
};

const coloredIconRed = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#f20a0a",
};

const detailsText = {
	fontSize: "16px",
	fontWeight: 600,
	padding: "5px"
}

const descriptionText = {
	fontSize: "15px",
	fontWeight: 400,
	fontStyle: "italic"
}

const formatNumberString = (numberString) => {
	const number = Number(numberString);
	if (isNaN(number)) {
		return "Invalid number string";
	}
	return number.toLocaleString();
};

const UnitDetails = () => {
	const location = useLocation();
  	const token = useSelector((state) => state.token)
  	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  	const { id } = location.state;
	const navigate = useNavigate();
	const [files, setFiles] = useState([]);
	const [existingImages, setExistingImages] = useState([]);
	const [description, setDescription] = useState("");
	const [uploading, setUploading] = useState(false);
	const [deleting, setDeleting] = useState(false);
	const [open, setOpen] = useState(false);
	const [openMeta, setOpenMeta] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [openSnack, setOpenSnack] = useState({open: false, message: "", severity: ""});

	const [unitDetails, setUnitDetails] = useState({})
	const [unitTerms, setUnitTerms] = useState({})

	const [unitName, setUnitName] = useState("");
	const [rentCurrency, setRentCurrency] = useState("");
	const [rentCycle, setRentCycle] = useState("");
	const [unitType, setUnitType] = useState("");
	const [unitRent, setUnitRent] = useState("");
	const [bedrooms, setBedrooms] = useState("");
	const [bathrooms, setBathrooms] = useState("");
	const [insideKitchen, setInsideKitchen] = useState(false);
	const [insideBathroom, setInsideBathroom] = useState(false);
	const [dstv, setDstv] = useState(false);
	const [fibre, setFibre] = useState(false);
	const [funished, setFurnished] = useState(false);
	const [store, setStore] = useState(false);
	const [hasDownPayment, setHasDownPayment] = useState("");
	const [downPayment, setDownPayment] = useState("");
	const [hasSecurityFee, setHasSecurityFee] = useState("");
	const [securityFee, setSecurityFee] = useState("");
	const [tempRef, setTempRef] = useState(0)
	const [changeReason, setChangeReason] = useState("MISTAKE")
	const [effectiveStartDate, setEffectiveStartDate] = useState("")
	const [useDeclaredRentForDisplay, setUseDeclaredRentForDisplay] = useState(false)
	const [declaredUnitRent, setDeclaredUnitRent] = useState("")
	const [declaredRentError, setDeclaredRentError] = useState("")
	const [allowedEffectiveDates, setAllowedEffectiveDates] = useState({
		has_restriction: false,
		allowed_range: "Any date"
	})

	let unitData={}


	const fetchUnitDetails = async () => {
		try {
			const response = await axios.get(`${baseURL}/landlords/rentals/units/details?unit_id=${id}`);
			setUnitDetails(response.data.data);
			setUnitName(response.data.data.unit_name);
			setUnitType(response.data.data.unit_type)
			setBedrooms(response.data.data.number_of_bedrooms)
			setBathrooms(response.data.data.number_of_bathrooms)
			setInsideKitchen(response.data.data.has_inside_kitchen)
			setInsideBathroom(response.data.data.has_inside_bathroom)
			setDstv(response.data.data.has_dstv_connection)
			setFibre(response.data.data.has_fibre_connection)
			setStore(response.data.data.has_store)
			setDescription(response.data.data.description || "")
			// setLoadingPropertyDetails(false);
		} catch (e) {
			// setLoadingPropertyDetails(false);
		}
	} 

	const fetchUnitTerms = async () => {
		try {
			const response = await axios.get(`${baseURL}/landlords/rentals/units/terms?unit_id=${id}`);
			setUnitTerms(response.data.data);
			setUnitRent(response.data.data.unit_rent)
			setRentCycle(response.data.data.unit_rent_cycle)
			setHasDownPayment(response.data.data.has_down_payment)
			setDownPayment(response.data.data.unit_cycle_down_payment)
			setHasSecurityFee(response.data.data.has_security_fee)
			setSecurityFee(response.data.data.unit_rent_security_fee)
			setRentCurrency(response.data.data.rent_currency)
			setUseDeclaredRentForDisplay(Boolean(response.data.data.use_declared_rent_for_display))
			setDeclaredUnitRent(response.data.data.declared_unit_rent || "")
			if (response.data.data.allowed_effective_dates) {
				setAllowedEffectiveDates(response.data.data.allowed_effective_dates)
			}
		} catch (e) {
			// setLoadingPropertyDetails(false);
		}
	} 

	const fetchUnitImages = async () => {
		try {
			const response = await axios.get(`${baseURL}/landlords/houses/images/upload?unit_id=${id}`);
			if (response.data.status === 200) {
				setExistingImages(response.data.data || []);
			}
		} catch (e) {
			console.error("Error fetching unit images:", e);
		}
	}

	const deleteUnitImage = async (imageId) => {
		try {
			setDeleting(true);
			const response = await axios.delete(`${baseURL}/landlords/houses/images/upload?image_id=${imageId}`);
			if (response.data.status === 200) {
				setOpenSnack({
					open: true,
					message: "Image deleted successfully",
					severity: "success",
				});
				// Refresh images after deletion
				await fetchUnitImages();
			}
		} catch (error) {
			setOpenSnack({
				open: true,
				message: "Failed to delete image. Please try again.",
				severity: "error",
			});
		} finally {
			setDeleting(false);
		}
	}

	const uploadUnitImages = async () => {
		if (!files.length) {
			setOpenSnack({
				open: true,
				message: "Please select at least one image to upload",
				severity: "warning",
			});
			return;
		}

		setUploading(true);
		const formData = new FormData();
		formData.append("unit_id", id);

		files.forEach((file) => {
			formData.append("images", file);
		});

		try {
			const response = await axios.post(
				`${baseURL}/landlords/houses/images/upload`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: `Bearer ${token}`,
					},
				}
			);
			
			if (response.data.status === 201) {
				setOpenSnack({
					open: true,
					message: "Images uploaded successfully!",
					severity: "success",
				});
				setFiles([]); // Clear files after upload
				await fetchUnitImages(); // Refresh images
			}
		} catch (error) {
			setOpenSnack({
				open: true,
				message: "Image upload failed. Please try again.",
				severity: "error",
			});
		} finally {
			setUploading(false);
		}
	}

	const handleCloseSnack = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setOpenSnack({ ...openSnack, open: false, message: "", severity: "" });
	};

	useEffect(() => {
		fetchUnitDetails()
		fetchUnitTerms()
		fetchUnitImages()
	}, [tempRef])

	const handleClickOpen = () => {
		setOpen(true);
	};
	
	const handleClose = () => {
		setOpen(false);
	};

	const handleClickOpenMeta = () => {
		setOpenMeta(true);
	};
	
	const handleCloseMeta = () => {
		setOpenMeta(false);
		setErrorMessage("");
	};

	const handleChangeUnitName = (event) => {
		setUnitName(event.target.value);
	};

	const handleChangeRentCurrency = (event) => {
		setRentCurrency(event.target.value);
	};

	const handleChangeRentCycle = (event) => {
		setRentCycle(event.target.value);
	};

	const handleChangeUnitType = (event) => {
		setUnitType(event.target.value);
	};

	const handleChangeUnitRent = (event) => {
		setUnitRent(event.target.value);
	};

	const handleChangeBedrooms = (event) => {
		setBedrooms(event.target.value);
	};

	const handleChangeBathrooms = (event) => {
		setBathrooms(event.target.value);
	};

	const handleChangeDescription = (event) => {
		setDescription(event.target.value);
	};

	const handleChangeInsideBathroom = (event) => {
		setInsideBathroom(event.target.checked);
		unitData["has_inside_bathroom"] = insideBathroom
	};
	
	const handleChangeInsideKitchen = (event) => {
		setInsideKitchen(event.target.checked);
		unitData["has_inside_kitchen"] = insideKitchen
	};

	const handleChangeDstv = (event) => {
		setDstv(event.target.checked);
	};
	
	const handleChangeFibre = (event) => {
		setFibre(event.target.checked);
	};

	const handleChangeStore = (event) => {
		setStore(event.target.checked);
	};
	
	const handleChangeFurnished = (event) => {
		setFurnished(event.target.checked);
	};

	const handleChangeReason = (event) => {
		setChangeReason(event.target.value);
	};

	const handleChangeEffectiveStartDate = (event) => {
		setEffectiveStartDate(event.target.value);
	};

	const handleChangeUseDeclaredRent = (event) => {
		const checked = event.target.checked;
		setUseDeclaredRentForDisplay(checked);
		if (!checked) {
			setDeclaredUnitRent("");
			setDeclaredRentError("");
		}
	};

	const handleChangeDeclaredUnitRent = (event) => {
		const value = event.target.value;
		setDeclaredUnitRent(value);
		if (value && unitRent && Number(value) >= Number(unitRent)) {
			setDeclaredRentError("Declared rent must be less than actual unit rent.");
		} else if (!value.trim()) {
			setDeclaredRentError("Declared rent is required when checkbox is enabled.");
		} else {
			setDeclaredRentError("");
		}
	};

	const validateDeclaredRent = () => {
		if (!useDeclaredRentForDisplay) {
			setDeclaredRentError("");
			return true;
		}
		const actual = Number(unitRent);
		const declared = Number(declaredUnitRent);
		if (!declaredUnitRent || Number.isNaN(declared) || declared <= 0) {
			setDeclaredRentError("Declared rent is required when using declared rent on receipts.");
			return false;
		}
		if (!actual || declared >= actual) {
			setDeclaredRentError("Declared rent must be less than actual unit rent.");
			return false;
		}
		setDeclaredRentError("");
		return true;
	};


	const handleRentalUnitMetaDataEditFormSubmit = async () => {
		try {
			// Clear previous errors
			setErrorMessage("");

			if (!validateDeclaredRent()) {
				return;
			}

			// Validate effective start date if there's a restriction
			if (changeReason === "INCREASE" && effectiveStartDate) {
				if (allowedEffectiveDates?.has_restriction && allowedEffectiveDates?.payment_day) {
					const selectedDate = new Date(effectiveStartDate);
					const dayOfMonth = selectedDate.getDate();
					
					if (dayOfMonth !== allowedEffectiveDates.payment_day) {
						setErrorMessage(`Invalid date: Only the ${allowedEffectiveDates.payment_day}th of any month is allowed`);
						return; // Prevent submission
					}
				}
			}

			const payload = {
				unit_rent: unitRent,
				unit_rent_cycle: rentCycle,
				change_reason: changeReason,
				use_declared_rent_for_display: useDeclaredRentForDisplay,
			};
			if (useDeclaredRentForDisplay) {
				payload.declared_unit_rent = String(declaredUnitRent);
			}
			if (changeReason === "INCREASE" && effectiveStartDate) {
				payload["effective_start_date"] = effectiveStartDate;
			}
			await axios.post(`${baseURL}/landlords/rentals/units/terms?unit_id=${id}`, payload);
			setOpenMeta(false);
			setErrorMessage("");
			setUnitRent("")
			setRentCycle("")
			setChangeReason("MISTAKE")
			setEffectiveStartDate("")
			setDeclaredRentError("")
			setTempRef(tempRef+1)
			fetchUnitTerms()
		} catch (err) {
			console.log(err);
			setErrorMessage(err.response?.data?.message || "An error occurred while updating unit metadata");
		}
	 };

	const handleUnitDetailsEditFormSubmit = async () => {
		try {
			await axios.post(
				`${baseURL}/landlords/rentals/units/details?unit_id=${id}`,
				{
					unit_name: unitName,
					unit_type: unitType,
					number_of_bedrooms: bedrooms,
					number_of_bathrooms: bathrooms,
					has_dstv_connection: dstv,
					has_fibre_connection: fibre,
					is_fully_furnished: funished,
					has_inside_bathroom: insideBathroom,
					has_inside_kitchen: insideKitchen,
					has_store: store,
					description: description,
				}
			);
			setOpen(false);
			setTempRef(tempRef + 1); // Refresh unit details
		} catch (err) {
			console.log(err);
		}
	};
  


  return (
    <Box m="20px" p="20px">
		<Breadcrumbs sx={{ padding: "20px", alignItems:"center" }} aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
          <Link
            underline="hover"
            sx={{ display: "flex", alignItems: "center" }}
            color="inherit"
            onClick={() => navigate("/propertyDetailsTab")}
          >
            <ApartmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Property Details
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center" }}
            color="text.primary"
          >
            <b>Unit Details</b>
          </Typography>
        </Breadcrumbs>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} >
              <Stack spacing={3} sx={{ marginBottom: "20px" }}>
                <FlexBetween>
                  <Typography variant="h4">Unit Details</Typography>
                  <FlexEnd onClick={handleClickOpen} sx={{
                    cursor: "pointer"
                  }}>
                    <Typography variant="h5" sx={{color:"#0759e8"}}>Edit Details</Typography>
                    <EditIcon sx={facilityIcons} />
                  </FlexEnd>
                </FlexBetween>
                <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "4px", padding: "1rem" }}>
                  <Grid container spacing={2} marginBottom={"15px"}>
                    <Grid item xs={12} sm={6}>
                      <Stack spacing={2}>
                        <FlexCenter>
                          <ChairOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>Unit Name: </Typography>
                          <Typography sx={detailsText}>{unitName}</Typography>
                        </FlexCenter>
                        <FlexCenter>
                          <BedOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>Unit Type: </Typography>
                          <Typography sx={detailsText}>{unitType}</Typography>
                        </FlexCenter>
                        <FlexCenter>
                          <BedOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>No. of Bedrooms: </Typography>
                          <Typography sx={detailsText}>{bedrooms}</Typography>
                        </FlexCenter>
                        <FlexCenter>
                          <ShowerOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>No. of Bathrooms: </Typography>
                          <Typography sx={detailsText}>{bathrooms}</Typography>
                        </FlexCenter>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Typography variant="h5">Amenities (Select all that apply to the unit)</Typography>
                  <Grid container spacing={2} marginTop={"10px"}>
                    <Grid item xs={12} sm={6}>
                      <Stack spacing={2}>
                        <FlexCenter>
                          <ChairOutlinedIcon sx={facilityIcons} />
                          <Typography>Has inside Kitchen?</Typography>
                          {insideKitchen ? (	
                            <CheckCircleIcon sx={coloredIconGreen} />
                          ) : (
                            <ClearIcon sx={coloredIconRed} />
                          )}
                        </FlexCenter>
                        <FlexCenter>
                          <BedOutlinedIcon sx={facilityIcons} />
                          <Typography>Has inside Bathroom?</Typography>
                          {insideBathroom ? (	
                            <CheckCircleIcon sx={coloredIconGreen} />
                          ) : (
                            <ClearIcon sx={coloredIconRed} />
                          )}
                        </FlexCenter>
                        <FlexCenter>
                          <CountertopsOutlinedIcon sx={facilityIcons} />
                          <Typography>Has Dstv Connection?</Typography>
                          {dstv ? (	
                            <CheckCircleIcon sx={coloredIconGreen} />
                          ) : (
                            <ClearIcon sx={coloredIconRed} />
                          )}
                        </FlexCenter>
                        <FlexCenter>
                          <WifiOutlinedIcon sx={facilityIcons} />
                          <Typography>Has Fibre Connection?</Typography>
                          {fibre ? (	
                            <CheckCircleIcon sx={coloredIconGreen} />
                          ) : (
                            <ClearIcon sx={coloredIconRed} />
                          )}
                        </FlexCenter>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack spacing={2}>
                        <FlexCenter>
                          <ChairOutlinedIcon sx={facilityIcons} />
                          <Typography>Is fully furnished?</Typography>
                          {funished ? (	
                            <CheckCircleIcon sx={coloredIconGreen} />
                          ) : (
                            <ClearIcon sx={coloredIconRed} />
                          )}
                        </FlexCenter>
                        <FlexCenter>
                          <StorefrontIcon sx={facilityIcons} />
                          <Typography>Has a store?</Typography>
                          {store ? (	
                            <CheckCircleIcon sx={coloredIconGreen} />
                          ) : (
                            <ClearIcon sx={coloredIconRed} />
                          )}
                        </FlexCenter>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            </Grid>

            <Grid item xs={12} >
              <Stack spacing={3} sx={{ marginBottom: "20px" }}>
                <FlexBetween>
                  <Typography variant="h4">Unit Metadata Details</Typography>
                  <FlexEnd onClick={handleClickOpenMeta} sx={{
                    cursor: "pointer"
                  }}>
                    <Typography variant="h5" sx={{color:"#0759e8"}}>Edit Metadata</Typography>
                    <EditIcon sx={facilityIcons} />
                  </FlexEnd>
                </FlexBetween>
                <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "4px", padding: "1rem" }}>
                  <Grid container spacing={2} marginBottom={"15px"}>
                    <Grid item xs={12} sm={6}>
                      <Stack spacing={2}>
                        <FlexCenter>
                          <ChairOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>Unit Rent: </Typography>
                          <Typography sx={detailsText}>{unitRent}</Typography>
                        </FlexCenter>
                        <FlexCenter>
                          <BedOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>Rent Currency: </Typography>
                          <Typography sx={detailsText}>{rentCurrency}</Typography>
                        </FlexCenter>
                        <FlexCenter>
                          <BedOutlinedIcon sx={facilityIcons} />
                          <Typography sx={descriptionText}>Rent Cycle: </Typography>
                          <Typography sx={detailsText}>{rentCycle}</Typography>
                        </FlexCenter>
                        {unitTerms?.use_declared_rent_for_display && (
                          <>
                            <FlexCenter>
                              <BedOutlinedIcon sx={facilityIcons} />
                              <Typography sx={descriptionText}>Declared rent (receipts): </Typography>
                              <Typography sx={detailsText}>
                                {formatNumberString(unitTerms.declared_unit_rent)}
                              </Typography>
                            </FlexCenter>
                            <FlexCenter>
                              <BedOutlinedIcon sx={facilityIcons} />
                              <Typography sx={descriptionText}>Receipt display ratio: </Typography>
                              <Typography sx={detailsText}>
                                {unitTerms.display_ratio != null
                                  ? `${Math.round(Number(unitTerms.display_ratio) * 100)}%`
                                  : "—"}
                              </Typography>
                            </FlexCenter>
                          </>
                        )}
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          <Grid item sx={{ display: { xs: "none", sm: "block" } }} xs={12} sm={6}>
            <Card sx={{marginBottom: "30px"}}>
              <CardContent sx={{ padding: 0 }}>
                <FlexStart sx={{ padding: "16px" }}>
                {/* <LandLordAvatar /> */}
                  <Box sx={{ marginLeft: "8px" }}>
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>
                      Unit Images
                    </Typography>
                  </Box>
                </FlexStart>
                <Divider />
                <Stack spacing={3} sx={{ padding: "16px" }}>
                  {/* Display existing images */}
                  {existingImages.length > 0 && (
                    <Box>
                      <Typography variant="h6" sx={{ marginBottom: "10px" }}>
                        Existing Images
                      </Typography>
                      <Grid container spacing={2}>
                        {existingImages.map((image) => (
                          <Grid item xs={6} sm={4} key={image.id}>
                            <Box
                              sx={{
                                position: "relative",
                                border: "1px solid #eaeaea",
                                borderRadius: "4px",
                                overflow: "hidden",
                                padding: "4px",
                              }}
                            >
                              <img
                                src={image.image}
                                alt={`Unit image ${image.id}`}
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                  display: "block",
                                }}
                              />
                              <IconButton
                                onClick={() => deleteUnitImage(image.id)}
                                disabled={deleting}
                                sx={{
                                  position: "absolute",
                                  top: "8px",
                                  right: "8px",
                                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                                  },
                                }}
                                size="small"
                              >
                                {deleting ? (
                                  <CircularProgress size={20} />
                                ) : (
                                  <DeleteIcon color="error" fontSize="small" />
                                )}
                              </IconButton>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}
                  
                  {/* Add new images section */}
                  <Box>
                    <Typography variant="h6" sx={{ marginBottom: "10px" }}>
                      Add New Images
                    </Typography>
                    <ImageUploader 
                      files={files} 
                      setFiles={setFiles}
                    />
                    {files.length > 0 && (
                      <Button
                        variant="contained"
                        onClick={uploadUnitImages}
                        disabled={uploading}
                        endIcon={uploading ? <CircularProgress size={20} /> : <SendIcon />}
                        sx={{ marginTop: "10px" }}
                        fullWidth
                      >
                        {uploading ? "Uploading..." : "Upload Images"}
                      </Button>
                    )}
                  </Box>
                </Stack>
              </CardContent>
            </Card>

            <Card >
              <CardContent sx={{ padding: 0 }}>
                <FlexStart sx={{ padding: "16px" }}>
                {/* <LandLordAvatar /> */}
                  <Box sx={{ marginLeft: "8px" }}>
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>
                      Terms and Conditions
                    </Typography>
                  </Box>
                </FlexStart>
                <Divider />
                <Stack spacing={3} sx={{ padding: "16px" }}>
                  <FlexCenter>
								
                    <Typography sx={descriptionText}>Inital Deposit: </Typography>
                    <Typography sx={detailsText}>{hasDownPayment ? downPayment : 0}</Typography>
                  </FlexCenter>
                  <FlexCenter>
                    
                    <Typography sx={descriptionText}>Security Deposit: </Typography>
                    <Typography sx={detailsText}>{hasSecurityFee ? securityFee : 0}</Typography>
                  </FlexCenter>
                </Stack>
              </CardContent>
            </Card>
            {/* <Grid sx={{marginTop:"30px"}}>
              <Button variant="contained" endIcon={<SendIcon />} onClick={handleRentalUnitFormSubmit} sx={{padding:"15px"}}>Submit Unit Details</Button>
            </Grid> */}
          </Grid>
        </Grid>
			<FormDialog
				open={open}
				handleClose={handleClose}
				enableActions={true}
				content={
					<UnitDetailsEditForm
						unitName={unitName}
						handleChangeUnitName={handleChangeUnitName}
						unitType={unitType}
						handleChangeUnitType={handleChangeUnitType}
						bedrooms={bedrooms}
						handleChangeBedrooms={handleChangeBedrooms}
						bathrooms={bathrooms}
						handleChangeBathrooms={handleChangeBathrooms}
						dstv={dstv}
						handleChangeDstv={handleChangeDstv}
						fibre={fibre}
						handleChangeFibre={handleChangeFibre}
						funished={funished}
						handleChangeFurnished={handleChangeFurnished}
						insideBathroom={insideBathroom}
						handleChangeInsideBathroom={handleChangeInsideBathroom}
						insideKitchen={insideKitchen}
						handleChangeInsideKitchen={handleChangeInsideKitchen}
						store={store}
						handleChangeStore={handleChangeStore}
						description={description}
						handleChangeDescription={handleChangeDescription}
					/>
				}
				title={"Edit Unit Details"}
				handleSubmit={handleUnitDetailsEditFormSubmit}
				buttonText="submit"
			/>

			<FormDialog
				open={openMeta}
				handleClose={handleCloseMeta}
				enableActions={true}
				errorMessage={errorMessage}
				setErrorMessage={setErrorMessage}
				content={
					<UnitMetaDataEditForm
						unitRent={unitRent}
						handleChangeUnitRent={handleChangeUnitRent}
						rentCycle={rentCycle}
						handleChangeRentCycle={handleChangeRentCycle}
						changeReason={changeReason}
						handleChangeReason={handleChangeReason}
						effectiveStartDate={effectiveStartDate}
						handleChangeEffectiveStartDate={handleChangeEffectiveStartDate}
						allowedEffectiveDates={allowedEffectiveDates}
						useDeclaredRentForDisplay={useDeclaredRentForDisplay}
						handleChangeUseDeclaredRent={handleChangeUseDeclaredRent}
						declaredUnitRent={declaredUnitRent}
						handleChangeDeclaredUnitRent={handleChangeDeclaredUnitRent}
						declaredRentError={declaredRentError}
					/>
				}
				title={"Edit Unit Meta Data Details"}
				handleSubmit={handleRentalUnitMetaDataEditFormSubmit}
				buttonText="submit"
			/>
			<TopSnack
				open={openSnack.open}
				handleCloseSnack={handleCloseSnack}
				message={openSnack.message}
				severity={openSnack.severity}
			/>
    </Box>
  );
};

export default UnitDetails;